import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconPresentation$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconPresentation extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '1efe733830ab4eba0bbc43364a116afb7d6b306a', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'e7fdcd93ccb218ea4e87379a0e2c6b4b5de076c4', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '2c2cc91824665ee163070bdcb2e9b55e626e276f', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "m11.208 15.052 5.5 2.538a.5.5 0 0 1 .246.663l-.209.454a.5.5 0 0 1-.663.246l-4.871-2.25a.5.5 0 0 0-.42 0l-4.867 2.248a.5.5 0 0 1-.663-.244l-.21-.454a.5.5 0 0 1 .243-.663l5.495-2.538a.5.5 0 0 1 .419 0M18.5 3a.5.5 0 0 1 .492.41L19 3.5v10a.5.5 0 0 1-.41.492L18.5 14h-15a.5.5 0 0 1-.492-.41L3 13.5v-10a.5.5 0 0 1 .41-.492L3.5 3zm-1 1.5h-13v8h13z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-presentation", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-presentation"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-presentation":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconPresentation$1);
            }
            break;
    } });
}

const CosmosIconPresentation = CosmosIconPresentation$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconPresentation, defineCustomElement };
